import React, { useEffect, useState } from "react";
import { useParams, Navigate } from "react-router-dom";
import "./servicesPage.css";

import {
  SERVICE_CONTENT,
  ServiceContentItem,
  ServiceCapability,
} from "./serviceContent";
import { easeOut, motion } from "framer-motion";

const fadeUp = {
  hidden: { opacity: 0, y: 18 },
  visible: (i = 1) => ({
    opacity: 1,
    y: 0,
    transition: { delay: i * 0.08, duration: 0.6, ease: easeOut },
  }),
};

type RouteParams = {
  service?: string;
};

const ServicesPage: React.FC = () => {
  const { service } = useParams<RouteParams>();
  const [openIndex, setOpenIndex] = useState<number | null>(null);
    useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "smooth", // remove if you want instant
    });
  }, []);

  if (!service || !(service in SERVICE_CONTENT)) {
    return <Navigate to="/services/consulting-service" replace />;
  }

  const content: ServiceContentItem = SERVICE_CONTENT[service];
 

  return (
    <section className="servicesPage-root">
      {/* ===== FULL WIDTH HERO ===== */}
      <section
        className="servicesPage-hero"
        style={{ backgroundImage: `url(${content.heroImage})` }}
      >
        <div className="servicesPage-heroOverlay" />
        <div className="servicesPage-heroContent">
          <h1>{content.title}</h1>
          <p>{content.subtitle}</p>
        </div>
      </section>

      {/* ===== CENTERED CONTENT ===== */}
      <section className="servicesPage-container">
        {/* Description */}
        <div className="servicesPage-card servicesPage-descriptionCard">
          <p>{content.description}</p>
        </div>


        {/* What We Do */}
<motion.div
  className="about__what "
  initial="hidden"
  whileInView="visible"
  viewport={{ once: true }}
>
  <h3 className="servicesPage-sectionTitle">What We Do</h3>

  <motion.p
    className="about__what-text servicesPage-card servicesPage-descriptionCard"
    variants={fadeUp}
    custom={1}
  >
    Designing and developing high-quality semiconductor systems requires deep
    technical expertise and a global perspective. At Nordic Integration Works
    AB, we bring together top engineering talent from around the world to
    deliver cutting-edge solutions for our customers — including leading
    telecom giants across the Nordic region.
  </motion.p>

  <motion.p
    className="about__what-text servicesPage-card servicesPage-descriptionCard"
    variants={fadeUp}
    custom={2}
  >
    Our core focus lies in supporting the telecom sector in Sweden, providing
    end-to-end consulting in semiconductor design, verification, and system
    integration. With a proven track record and a strong engineering
    foundation, we are expanding our capabilities to serve a broader range of
    high-tech industries such as IoT, Automotive, AI, and SAP/IT.
  </motion.p>

  <motion.p
    className="about__what-text servicesPage-card servicesPage-descriptionCard"
    variants={fadeUp}
    custom={3}
  >
    By combining innovation, precision, and collaboration, we help our clients
    accelerate product development, streamline operations, and achieve
    superior performance in a rapidly evolving market.
  </motion.p>
</motion.div>
        {/* Capabilities */}
        <div className="servicesPage-section">
          <h2 className="servicesPage-sectionTitle">Core Capabilities</h2>

          <div className="servicesPage-capabilityGrid">
            {content.capabilities.map(
              (cap: ServiceCapability, index: number) => (
                <div
                  key={index}
                  className={`servicesPage-capabilityCard ${
                    openIndex === index ? "open" : ""
                  }`}
                  onClick={() =>
                    setOpenIndex(openIndex === index ? null : index)
                  }
                >
                  <div className="servicesPage-capHeader">
                    <div>
                      <h3>{cap.title}</h3>
                      <p>{cap.summary}</p>
                    </div>
                    <span className="servicesPage-toggle">
                      {openIndex === index ? "–" : "+"}
                    </span>
                  </div>

                  <div className="servicesPage-capBody">
                    <p>{cap.details}</p>
                  </div>
                </div>
              )
            )}
          </div>
        </div>



        {/* Highlights */}
        <div className="servicesPage-section">
          <h2 className="servicesPage-sectionTitle">
            Why Nordic Integration
          </h2>

          <div className="servicesPage-highlightGrid">
            {content.highlights.map((item, i) => (
              <div key={i} className="servicesPage-highlightCard">
                {item}
              </div>
            ))}
          </div>
        </div>

        {/* CTA */}
        {/* <div className="servicesPage-ctaCard">
          <h3>Ready to accelerate your next project?</h3>
          <a href="/contact-us">Contact Us</a>
        </div> */}
      </section>
    </section>
  );
};

export default ServicesPage;
